import KeyIcon from '@mui/icons-material/Key'
import { Box, Button, Container, Link, List, ListItem, ListItemText, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import AddIcon from '@mui/icons-material/Add'

import { AlertComponent } from 'src/components/Alert/AlertComponent'
import useProtectedPage from 'src/hooks/useProtectedPage'
import ApiKeysTable from './components/Table/ApiKeysTable'
import { goToCreateApiKey } from 'src/routes/coordinator'
import { getPermissions } from 'src/service/authService'
import { NoteCard } from 'src/components/NoteCard/NoteCard'
import { ModalCreatedApiKey } from './components/Modal/CreatedApiKeyModal'

const getApiUrl = (): string => {
  const currentUrl = window.location.hostname;
  if (currentUrl === 'localhost') return 'https://dev-api.itbuzz.com.br/api/docs/'
  if (currentUrl.startsWith('dev-')) return 'https://dev-api.itbuzz.com.br/api/docs/'
  else return 'https://api.itbuzz.com.br/api/docs/'
}

export const ListApiKeys = () => {
  useProtectedPage()
  const history = useNavigate()
  const { t } = useTranslation()
  const permissions = JSON.parse(getPermissions())

  return (
    <Container
      sx={{
        mt: '96px',
      }}
    >
      <AlertComponent />
      <ModalCreatedApiKey />
      <Box
        component="div"
        sx={{
          color: '#FF5E1E',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: '24px',
        }}
      >
        <Box sx={{ display: 'flex', gap: '8px' }}>
          <KeyIcon />
          <Typography
            variant="h6"
            sx={{
              fontWeight: '500',
              fontSize: '20px',
              lineHeight: '160%',
              letterSpacing: ' 0.15px',
              color: ' #FF5E1E',
              marginTop: '-4px',
            }}
          >
            {t('apikey.title')}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ my: 4 }}>
        <NoteCard
          title={t('apikey.page.information.title')}
          content={
            <Typography sx={{ color: '#000', textAlign: 'left' }}>
              {t('apikey.page.information.content.api') + ' '}
              <Link
                href={getApiUrl()}
                underline='hover'
                sx={{ color: '#FF5E1E', fontWeight: 500 }}
                target='_blank'
                rel='noreferrer'
              >
                {t('apikey.page.information.content.link')}
              </Link>
              .<Typography sx={{ mt: 2 }}>{t('apikey.page.information.content.content1')}</Typography>
              <List sx={{ listStyleType: 'disc', pl: 6, py: 0 }}>
                <ListItem sx={{ display: 'list-item', py: 0, pl: 0.5 }}>
                  <ListItemText primary={t('apikey.page.information.content.content2')} />
                </ListItem>
                <ListItem sx={{ display: 'list-item', py: 0, pl: 0.5 }}>
                  <ListItemText primary={t('apikey.page.information.content.content3')} />
                </ListItem>
                <ListItem sx={{ display: 'list-item', py: 0, pl: 0.5 }}>
                  <ListItemText primary={t('apikey.page.information.content.content4')} />
                </ListItem>
              </List>
            </Typography>
          }
        />
      </Box>

      <Button
        onClick={() => goToCreateApiKey(history)}
        disabled={!permissions?.apikey?.includes("apikey:create")}
        variant="outlined"
        sx={{
          gap: '6px',
          width: '50%',
          height: '36px',
          mb: '20px',
          ':hover': {
            backgroundColor: '#FF5E1E',
            color: '#ffff',
          },
        }}
      >
        <AddIcon sx={{ width: '24px', height: '24px' }} />
        {t('apikey.button.create')}
      </Button>

      <ApiKeysTable />
    </Container>
  )
}
